import Head from 'next/head'
import { useRouter } from 'next/router'
import metaImage from '@/assets/images/edhrec_preview.png'

type ExplicitProps = {
  title: string
  description?: string
  keywords?: string
  imageUrl?: string
  noindex?: boolean
}

const defaultEDHRECDescription = "MTG games by EDHREC."
const defaultKeywords = 'Magic: the Gathering, MTG, games, word games, spellify'
export const CHGamesHead = ({ title, description, keywords, imageUrl, noindex }: ExplicitProps) => {
  const router = useRouter()

  const appendedTitle = title + " - EDHREC Games"

  const image = imageUrl ? imageUrl : metaImage.src

  return (
    <>
      <Head>
        <title>{appendedTitle}</title>
        <meta property='og:title' content={appendedTitle} />
        <meta name='title' content={appendedTitle} />
        <meta property='og:description' content={description} />
        <meta name='description' content={description ||  defaultEDHRECDescription} />
        <meta property='og:url' content={`https://edhrec.com/games${router.asPath}`} />
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content="EDHREC Games" />
        <meta property='og:keywords' content={keywords || defaultKeywords} />
        <meta name='keywords' content={keywords} />
        <meta property='og:image' content={image} />
        <meta name='twitter:card' content='summary_small_image' />
        <meta name='twitter:image:alt' content= "EDHREC Games" />
        {noindex && <meta name='robots' content='noindex' />}
      </Head>
    </>
  )
}

export default CHGamesHead